const TABS = {
  COGNITO: 0,
  TRULIOO: 1,
  LEXIS: 2,
};

export default TABS;
